export default __webpack_public_path__ + "static/media/Card 2.fbfa777e.png";